<template>
  <div :class="classCustom">
    <slot name="content" />
  </div>
</template>


<script>
export default {
  name: 'detail-template',
  props: ['classCustom']
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/detail.vue